export default "__VITE_ASSET__9d19c531__"